import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const payment = createAsyncThunk("payment", async (data, { rejectWithValue }) => {
    try {
      const config = { headers: { "Content-Type": "application/json" }, withCredentials: true };
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/cashfree-payment`,
        data,
        config
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data.message);
    }
});

const paymentVerify = createAsyncThunk("paymentVerify", async (data, { rejectWithValue }) => {
    try {
      const config = { headers: { "Content-Type": "application/json" }, withCredentials: true };
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/cashfree-payment-verify`,
        data,
        config
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data.message);
    }
});


export {payment, paymentVerify};